import type {
  BrandCouponCreateApiData,
  BrandCouponCreateApiResponses,
  BrandCreateApiData,
  BrandCreateApiResponses,
  BrandGetApiData,
  BrandGetApiResponses,
  BrandGetByDomainApiData,
  BrandGetByDomainApiResponses,
  BrandGetByOrgApiData,
  BrandGetByOrgApiResponses,
  BrandInsightsGetApiData,
  BrandInsightsGetApiResponses,
  BrandInsightsLinkGetApiData,
  BrandInsightsLinkGetApiResponses,
  BrandInsightsLinkRotateApiData,
  BrandInsightsLinkRotateApiResponses,
  BrandInsightsLiveGetApiData,
  BrandInsightsLiveGetApiResponses,
  BrandInsightsPartnersGetApiData,
  BrandInsightsPartnersGetApiResponses,
  BrandListApiData,
  BrandListApiResponses,
  BrandMinimalListApiData,
  BrandMinimalListApiResponses,
  BrandPatchApiData,
  BrandPatchApiResponses,
  ReferralSettingsGetApiData,
  ReferralSettingsGetApiResponses,
  ReferralSettingsPatchApiData,
  ReferralSettingsPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getBrandUrls = {
  getBrand: dataEndpoint<BrandGetApiData, BrandGetApiResponses>({
    getUrl: ({ brandId }) => apiUrl(`brands/${brandId}/`)
  }),
  getByDomainBrand: dataEndpoint<BrandGetByDomainApiData, BrandGetByDomainApiResponses>({
    getUrl: ({ brandDomain }) => apiUrl(`brands/by-domain/${brandDomain}/`)
  }),
  getBrandByOrg: dataEndpoint<BrandGetByOrgApiData, BrandGetByOrgApiResponses>({
    getUrl: (queryParams) => apiUrl('brands/by-org/', queryParams)
  }),
  getBrandInsights: dataEndpoint<BrandInsightsGetApiData, BrandInsightsGetApiResponses>({
    getUrl: ({ insightsToken, ...queryParams }) =>
      apiUrl(`brand-insights/${encodeURIComponent(insightsToken)}/`, queryParams)
  }),
  getBrandInsightsPartners: dataEndpoint<BrandInsightsPartnersGetApiData, BrandInsightsPartnersGetApiResponses>({
    getUrl: ({ insightsToken, ...queryParams }) =>
      apiUrl(`brand-insights/${encodeURIComponent(insightsToken)}/partners/`, queryParams)
  }),
  getBrandInsightsLink: dataEndpoint<BrandInsightsLinkGetApiData, BrandInsightsLinkGetApiResponses>({
    getUrl: ({ brandId }) => apiUrl(`brands/${brandId}/insights-link/`)
  }),
  postRotateBrandInsightsLink: responseEndpoint<BrandInsightsLinkRotateApiData, BrandInsightsLinkRotateApiResponses>({
    getUrl: ({ brandId }) => apiUrl(`brands/${brandId}/insights-link/rotate/`),
    getBody: ({ brandId: _brandId, ...body }) => body
  }),
  getBrandInsightsLive: dataEndpoint<BrandInsightsLiveGetApiData, BrandInsightsLiveGetApiResponses>({
    getUrl: ({ insightsToken }) => apiUrl(`brand-insights/${encodeURIComponent(insightsToken)}/live/`)
  }),
  patchBrand: responseEndpoint<BrandPatchApiData, BrandPatchApiResponses>({
    getUrl: ({ brandId }) => apiUrl(`brands/${brandId}/`),
    getBody: (data) => data
  }),
  patchBrandImage: responseEndpoint<BrandPatchApiData, BrandPatchApiResponses>({
    getUrl: ({ brandId }) => apiUrl(`brands/${brandId}/`),
    getHeaders: () => ({
      'Content-Type': 'multipart/form-data'
    }),
    getBody: (data) => data,
    skipBodyTransformation: true
  }),
  getPaginatedBrands: dataEndpoint<BrandListApiData, BrandListApiResponses>({
    getUrl: (queryParams) => apiUrl('brands/', queryParams)
  }),
  getPaginatedMinimalBrands: dataEndpoint<BrandMinimalListApiData, BrandMinimalListApiResponses>({
    getUrl: (queryParams) => apiUrl('brands/minimal/', queryParams)
  }),
  postBrand: responseEndpoint<BrandCreateApiData, BrandCreateApiResponses>({
    getUrl: () => apiUrl('brands/'),
    getHeaders: () => ({
      'Content-Type': 'multipart/form-data'
    }),
    getBody: (data) => data,
    skipBodyTransformation: true
  }),
  postBrandCoupon: responseEndpoint<BrandCouponCreateApiData, BrandCouponCreateApiResponses>({
    getUrl: ({ brandId }) => apiUrl(`brands/${brandId}/coupons/`),
    getBody: ({ brandId: _brandId, ...body }) => body
  }),
  getBrandReferralSettings: dataEndpoint<ReferralSettingsGetApiData, ReferralSettingsGetApiResponses>({
    getUrl: ({ brandId, ...queryParams }) => apiUrl(`brands/${brandId}/referral-settings/`, queryParams)
  }),
  patchBrandReferralSettings: responseEndpoint<ReferralSettingsPatchApiData, ReferralSettingsPatchApiResponses>({
    getUrl: ({ brandId }) => apiUrl(`brands/${brandId}/referral-settings/`),
    getBody: ({ brandId: _brandId, ...body }) => body
  })
};
